export default __webpack_public_path__ + "static/propmesign-b5b92361c0976b709f342b2696562ba2.png";